"use client";

import { Input } from "@headlessui/react";
import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";

const SelectPatientSearch = ({
  onSearchChange,
  placeholder = "Zoeken patient op",
  search = "",
}) => {
  const [localSearch, setLocalSearch] = useState(search);

  const debouncedSearch = useMemo(
    () => debounce((query) => onSearchChange?.(query), 300),
    [onSearchChange]
  );

  useEffect(() => {
    setLocalSearch(search);
  }, [search]);

  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

  return (
    <div className="w-full rounded-md">
      <Input
        placeholder={placeholder}
        className="block w-full rounded-md border border-wa-border bg-wa-panel2 py-2 pl-3 pr-3 text-sm text-wa-text outline-none placeholder:text-wa-muted focus:border-wa-accent focus:ring-1 focus:ring-wa-accent"
        value={localSearch}
        onChange={(event) => {
          const nextSearch = event.target.value;
          setLocalSearch(nextSearch);
          if (typeof localStorage !== "undefined") {
            localStorage.setItem("QUERY", nextSearch);
          }
          debouncedSearch(nextSearch);
        }}
      />
    </div>
  );
};

export default SelectPatientSearch;
